var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(-16 -1559)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(16 1559)",
    fill: "#ffb109"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Send",
    "data-name": "Iconly/Bold/Send",
    transform: "translate(23.398 1567.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M22.548.675a2.243,2.243,0,0,0-2.24-.584L1.633,5.522A2.227,2.227,0,0,0,.028,7.286a2.614,2.614,0,0,0,1.163,2.44L7.03,13.315A1.513,1.513,0,0,0,8.9,13.091l6.686-6.728a.851.851,0,0,1,1.23,0,.885.885,0,0,1,0,1.238l-6.7,6.729a1.535,1.535,0,0,0-.224,1.878l3.568,5.9a2.216,2.216,0,0,0,1.927,1.1,2.4,2.4,0,0,0,.29-.012,2.261,2.261,0,0,0,1.892-1.612L23.105,2.929A2.279,2.279,0,0,0,22.548.675",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.daa8a9c09af7c2902a9183e074159f6d.svg";
export { ForwardRef as ReactComponent };